import { PricingTierEnum } from '../../fleet-operations/model-family/model-family-pricing-tier'
import { SalesQuoteSeasonType } from './sales-quote-season-type'

const modelFamilyDefaultPricingTierConfiguration = {
  [PricingTierEnum.Enum.Core]: 1,
  [PricingTierEnum.Enum.Premium]: 1.1,
  [PricingTierEnum.Enum.ExceptionOnly]: 1.2
}

const modelFamilyMarinePricingTierConfiguration = {
  [PricingTierEnum.Enum.Core]: 1,
  [PricingTierEnum.Enum.Premium]: 1.4
}

const modelFamilySNOPricingTierConfiguration = {
  [PricingTierEnum.Enum.Core]: 0,
  [PricingTierEnum.Enum.Premium]: 1
}

export function getFamilyPricingTierConfiguration(type: SalesQuoteSeasonType): { [key: string]: number } {
  switch (type) {
    case 'SNO':
      return modelFamilySNOPricingTierConfiguration
    case 'MARINE':
      return modelFamilyMarinePricingTierConfiguration
    default:
      return modelFamilyDefaultPricingTierConfiguration
  }
}
